import React from 'react';
import { Box } from '@mui/material';

import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';

import Header from '../../Common/Header/Header';
import IgdChartsContainer from '../Common/IgdChartsContainer';
import FamilyAllowance from './FamilyAllowance';
import BasicBenefits from './BasicBenefits';
import Payments from './Payments';
import BPCWrapper from './BPC';

const menus = [
    {
        title: 'Bolsa Família',
        path: '/governanceroom/dashboardigd/Benefits/FamilyAllowance',
    },
    {
        title: 'Pagamentos Bolsa Família',
        path: '/governanceroom/dashboardigd/Benefits/Payments',
    },
    {
        title: 'Benefícios Básicos e Variáveis',
        path: '/governanceroom/dashboardigd/Benefits/BasicBenefits',
    },
    {
        title: 'BPC',
        path: '/governanceroom/dashboardigd/Benefits/BPC',
    },
];

const titleMap = {
    '/governanceroom/dashboardigd/Benefits':
        'Indicadores Gerais de Benefícios',

    '/governanceroom/dashboardigd/Benefits/FamilyAllowance':
        'Indicadores Gerais do Bolsa Família',
        
    '/governanceroom/dashboardigd/Benefits/Payments':
        'Indicadores Gerais de Pagamentos Bolsa Família',

    '/governanceroom/dashboardigd/Benefits/BasicBenefits':
        'Indicadores Gerais de Benefícios Básicos e Variáveis',

    '/governanceroom/dashboardigd/Benefits/BPC':
        'Indicadores Gerais do BPC'
};

const Benefits = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardigd');
    };

    return (
        <Box>

            <Header
                menus={menus}
                onHomeClick={handleHomeClick}
            />

            <Box className="content">

                <IgdChartsContainer title={titleMap[location.pathname]} className="services-container-dashboards">

                    <Routes>

                        <Route
                            index
                            element={
                                <Navigate
                                    to="FamilyAllowance"
                                    replace
                                />
                            }
                        />

                        <Route
                            path="FamilyAllowance"
                            element={<FamilyAllowance />}
                        />

                        <Route
                            path="Payments"
                            element={<Payments />}
                        />

                        <Route
                            path="BasicBenefits"
                            element={<BasicBenefits />}
                        />

                        <Route
                            path="BPC"
                            element={<BPCWrapper />}
                        /> 

                    </Routes>

                </IgdChartsContainer>

            </Box>

        </Box>
    );
};

export default Benefits;
